import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import { Plugin } from '@nuxt/types'

Vue.use(Vuetify)

const plugin: Plugin = context => {
  const vuetify = new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#4769CB'
        }
      },
      options: {
        minifyTheme(css: string) {
          return process.env.NODE_ENV === 'production'
            ? css.replace(/[\r\n|\r|\n]/g, '')
            : css
        }
      }
    },
    icons: {
      iconfont: 'mdi'
    }
  })

  context.app.vuetify = vuetify
  context.$vuetify = vuetify.framework
}

export default plugin
